// @ts-check
import * as sentry from "./sentry"

export const apiBaseURL = "https://webmakers.mocoapp.com/api/v1/"
export const sentryDSN = ""
export const sentryTracingOrigins = [
    "localhost",
    apiBaseURL,
    // more api trace urls here
    /^\//,
]
export const sentryEnvironment = "master"

// need to execute early for fetch wrapping
// will be uncommented via drone CI
// sentry.init(sentryDSN, sentryTracingOrigins, sentryEnvironment)

export const calenderTheme = {
    calendar: {
        width: "400px",
        maxWidth: "100vw",
        legend: {
            height: "45px",
        },
        shadow: "0px 10px 26px rgba(0, 0, 0, 0.25)",
        colors: {
            text: {
                primary: "#333",
                highlight: "#fff",
            },
            background: {
                primary: "#fff",
                highlight: "var(--colors-red-500)",
                hover: "#eee",
            },
            border: "#eee",
        },
        font: {
            regular: "1.2em",
            large: "12em",
        },
        grid: {
            disabledOpacity: ".35",
            outsiderOpacity: ".6",
        },
    },
}

export const defaultUser = 933637218 // marc

export const symbolCodes: SymbolCode[] = [
    0, 13, 11, 9, 10, 7, 12, 1, 2, 3, 4, 5, 6, 8,
]
